import React, { useState } from "react";
import "./ShowGenerateModal.scss";
import ReactModal from "react-modal";
import { Button } from "react-bootstrap";
import { useEffect } from "react";
import {
  FlattenListOfPdfs,
  generatePDFAndDownload,
  ListOfPdfs,
} from "../../../api/index";
import Select from "react-select";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

const ShowGenerateModal = ({ show, onClose, slug, user }) => {
  const [activePDF, setActivePDF] = useState([]);
  const [show_spinner, setShowSpinner] = useState(false);
  const [list_of_pdfs, setListOfPdfs] = useState({});
  const [files_options, setFileOptions] = useState([]);

  const [selectedTypeOfBanks, setSelectedTypeOfBanks] = useState({});
  const [selected_files, setSelectedFiles] = useState();
  const [errors, setErrors] = useState([]);

  const onChangeTypeofBanks = (value) => {
    setSelectedTypeOfBanks(value);
    let processor_files = list_of_pdfs[value.value];
    let applications = processor_files.application.map((app) => ({ value: app, label: app }));
    let addendums = processor_files.addendums.map((addendum) => ({ value: addendum, label: addendum }));
    let file_ops = [
      {
        label: 'Applications',
        options: applications,
      },
      {
        label: 'Addendums',
        options: addendums,
      },
    ];
    setFileOptions(file_ops);
  };
  const onChangeFileSelect = (value) => {
    setSelectedFiles(value);
  };
  const handleSubmit = (action_type) => {
    if (selectedTypeOfBanks.value) {
      setShowSpinner(true);
      generatePDFAndDownload({
        slug: slug,
        pdf_file_name: selected_files.value,
        bank: selectedTypeOfBanks.value,
        action_type: action_type
      }).then(res => {
        setShowSpinner(false);
        if (res.status) {
          if (res.action_type == 'download') {
            window.open(res.fileUrl, "_blank", "noreferrer");
          } else {
            MySwal.fire({
              title: <p>Email sent for signature</p>,
              icon: 'success',
              toast: true,
              position: 'top-end',
              timer: 4000,
              timerProgressBar: true,
              showConfirmButton: false,
              customClass: 'margin-top-sweetalert',
              didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
                onClose();
              },
            })
          }
        }
      })
        .catch(error => {
          setErrors(error.data.errors)
        })
    }
  }
  useEffect(() => {
    ListOfPdfs().then(res => {
      setListOfPdfs(res?.data?.bank_file_mapping);
      let processor_options = Object.entries(res?.data?.bank_file_mapping).map(([key, val]) => {
        return {
          label: key,
          value: key,
        }
      });

      if (user.is_ems_user) {
        processor_options = processor_options.filter((item) =>
          item.label.includes("EMS"),
        );
      }

      setActivePDF(processor_options);
    });
  }, []);
  return (
    <ReactModal isOpen={show} className="show-generate-modal">
      <div>
        <h4 className="text-left">Generate and Download</h4>
        {activePDF.length ? (
          <Select
            name="colors"
            isLoading={show_spinner}
            isDisabled={show_spinner}
            options={activePDF}
            onChange={onChangeTypeofBanks}
            className="basic-multi-select"
            classNamePrefix="select"
          />
        ) : (
          <></>
        )}

        {Object.entries(selectedTypeOfBanks).length > 0 ?
          <>
            <br />
            <Select
              name="files"
              isLoading={show_spinner}
              isDisabled={show_spinner}
              options={files_options}
              onChange={onChangeFileSelect}
              className="basic-multi-select"
              classNamePrefix="select"
            // isMulti
            />
          </>
          : <></>}
      </div>

      <br />
      {Array.isArray(errors) && errors.map(error => (
        <p className='text-danger' >{error}</p>
      ))}

      <div className='assignbankbtnsection'>
        {selectedTypeOfBanks?.value ? <Button className='assignbanksendbtn' disabled={show_spinner} onClick={() => handleSubmit('send_for_signature')}>Send For Signature</Button> : <></>}
        {selectedTypeOfBanks?.value ? <Button className='assignbanksendbtn' disabled={show_spinner} onClick={() => handleSubmit('download')}>Download</Button> : <></>}
        <Button className='assignbankcancelbtn' onClick={onClose}>Cancel</Button>
      </div>

    </ReactModal>
  );

}

export default ShowGenerateModal
